export function formatDate(value) {
  if (!value) return "";

  const safe = String(value).replace(" ", "T");
  const d = new Date(safe);

  if (isNaN(d.getTime())) return value;

  const pad = (n) => String(n).padStart(2, "0");

  const time = `${pad(d.getHours())}:${pad(d.getMinutes())}`;
  const date = `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;

  return `${time} ${date}`;
}
